export const abbreviateNumber = (number?: number) => {
  return number !== undefined
    ? Intl.NumberFormat("en-US", {
        notation: "compact",
        maximumFractionDigits: 1,
      }).format(number)
    : "—"
}
